/* © CNES */
import * as olSource from 'ol/source';

/**
 * XYZ source.
 */
function xyz({
  url,
  attributions,
  maxZoom,
}: {
  url: string | undefined;
  attributions: any;
  maxZoom: number | undefined;
}) {
  return new olSource.XYZ({ url, attributions, maxZoom });
}

export default xyz;
